import { render, staticRenderFns } from "./Dictionary.vue?vue&type=template&id=50b1f0f6&scoped=true&"
import script from "./Dictionary.vue?vue&type=script&lang=ts&"
export * from "./Dictionary.vue?vue&type=script&lang=ts&"
import style0 from "./Dictionary.vue?vue&type=style&index=0&id=50b1f0f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b1f0f6",
  null
  
)

export default component.exports